import {
  DoorOpen,
  GraduationCap,
  LayoutGrid,
  type LucideIcon,
  MessageCircle,
  Plus,
  Ticket,
  Users,
} from 'lucide-react';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** short verb shown in the command palette */
  hint?: string;
};

export type NavGroup = { id: string; label: string; items: NavItem[] };

export const NAV_GROUPS: NavGroup[] = [
  {
    id: 'ops',
    label: 'Operasyon',
    items: [
      {
        to: '/admin',
        label: 'Onay Masası',
        icon: Ticket,
        end: true,
        hint: 'Ön rezervasyon onayla',
      },
      {
        to: '/admin/salon-girisi',
        label: 'Salon Girişi',
        icon: DoorOpen,
        hint: 'Davetiye tara · giriş',
      },
    ],
  },
  {
    id: 'manage',
    label: 'Yönetim',
    items: [
      {
        to: '/admin/ozet',
        label: 'Dashboard',
        icon: LayoutGrid,
        hint: 'Salon doluluğu ve metrikler',
      },
      {
        to: '/admin/rezervasyonlar',
        label: 'Rezervasyonlar',
        icon: Users,
        end: true,
        hint: 'Listele · filtrele',
      },
      {
        to: '/admin/rezervasyonlar/yeni',
        label: 'Manuel Rezervasyon',
        icon: Plus,
        hint: 'Gişe / telefon kaydı',
      },
      {
        to: '/admin/ogrenciler',
        label: 'Öğrenciler',
        icon: GraduationCap,
        hint: 'Davetiye listesi · ekle / düzenle',
      },
      {
        to: '/admin/whatsapp',
        label: 'WhatsApp',
        icon: MessageCircle,
        hint: 'Davetiye gönderim durumu',
      },
    ],
  },
];

export const NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((g) => g.items);
